module.exports = __webpack_public_path__ + "img/team-13.32549483.jpg";